/*! Copyright 2012, Ben Lin (http://dreamerslab.com/)
* Licensed under the MIT License (LICENSE.txt).
*
* Version: 1.0.19
*
* Requires: jQuery >= 1.2.3
*/
(function(a){if(typeof define==="function"&&define.amd){define(["jquery"],a);
}else{a(jQuery);}}(function(a){a.fn.addBack=a.fn.addBack||a.fn.andSelf;a.fn.extend({actual:function(b,l){if(!this[b]){throw'$.actual => The jQuery method "'+b+'" you called does not exist';
}var f={absolute:false,clone:false,includeMargin:false,display:"block"};var i=a.extend(f,l);var e=this.eq(0);var h,j;if(i.clone===true){h=function(){var m="position: absolute !important; top: -1000 !important; ";
e=e.clone().attr("style",m).appendTo("body");};j=function(){e.remove();};}else{var g=[];var d="";var c;h=function(){c=e.parents().addBack().filter(":hidden");
d+="visibility: hidden !important; display: "+i.display+" !important; ";if(i.absolute===true){d+="position: absolute !important; ";}c.each(function(){var m=a(this);
var n=m.attr("style");g.push(n);m.attr("style",n?n+";"+d:d);});};j=function(){c.each(function(m){var o=a(this);var n=g[m];if(n===undefined){o.removeAttr("style");
}else{o.attr("style",n);}});};}h();var k=/(outer)/.test(b)?e[b](i.includeMargin):e[b]();j();return k;}});}));

jQuery(document).ready(function() {
	jQuery('.globe').click(function() {
		$('.translationUlNav').fadeToggle('fast');
		$('.globe').toggleClass('grayActive');
		$('.globeIcon').toggle();
		$('.globeIconClose').toggle();
	});
	

	jQuery( ".staffLevel" ).last().css( "padding-bottom", "100px" );
	jQuery( ".staffLevel" ).first().css( "padding", "40px 0px 20px" );
	// jQuery('.table-scroll').wrap('<div class="rightOverlayTable"></div>');

	jQuery('.staffLevel').first().append('<img src="/wp-content/themes/TNECD/assets/images/csTexture.png" alt="filter background" class="filterBg">');

	jQuery('.sf-field-search label').append('<i class="fal fa-search"></i>');
	// jQuery('.sf-field-taxonomy-type label').append('<i class="fal fa-angle-down"></i>');
	// jQuery('.sf-field-taxonomy-acreage label').append('<i class="fal fa-angle-down"></i>');
	// jQuery('.sf-field-taxonomy-region label').append('<i class="fal fa-angle-down"></i>');
	// jQuery('.sf-field-taxonomy-industry label').append('<i class="fal fa-angle-down"></i>');
	// jQuery('.sf-field-category label').append('<i class="fal fa-angle-down"></i>');

	jQuery('#search-filter-form-7661').append('<i class="fal fa-spinner-third fa-spin"></i>');
	

	jQuery('.publicationLevel').first().append('<img src="/wp-content/themes/TNECD/assets/images/csTexture.png" alt="filter background" class="filterBg">');

	// jQuery(".accordion").on("up.zf.accordion", function(event) {
	// 	setTimeout(function(){
	// 		$('html,body').animate({scrollTop: $('.is-active').offset().top -10}, 'slow');
	// 	}, 50); //Adjust to match slideSpeed
	// }); 


	jQuery(".staffCard").mouseover(function() {
		$(this).find('.boxInfo').css('opacity', '1');
	});
	jQuery(".staffCard").mouseleave(function() {
		$(this).find('.boxInfo').css('opacity', '0');
	});


	jQuery('#Layer_1 path[data-county]').hover(function() {
		$('path[data-county=' + $(this).attr('data-county') + ']').addClass('hhhhhhhhhhhh');
	}, function() {
		$('path[data-county=' + $(this).attr('data-county') + ']').removeClass('hhhhhhhhhhhh');
	});
	jQuery(".legendCell01 .menu li:first-child").click(function() {
		$('.certifiedSiteIcon').fadeToggle();
	});
	jQuery(".legendCell02 .menu li:first-child").click(function() {
		$('.fourCollegeIcon').fadeToggle();
	});
	jQuery(".legendCell02 .menu li:nth-child(2)").click(function() {
		$('.communityCollegeIcon').fadeToggle();
	});
	jQuery(".legendCell03 .menu li:nth-child(1)").click(function() {
		$('.commercialAirportIcon').fadeToggle();
	});
	jQuery(".legendCell03 .menu li:nth-child(2)").click(function() {
		$('.generalAirportIcon').fadeToggle();
	});
	jQuery(".legendCell03 .menu li:nth-child(3)").click(function() {
		$('.majorPortIcon').fadeToggle();
	});

	
		var $select = $( "#gtranslate_selector" ).selectize();

		// Clear selected items from selectize control on dropdown click
		jQuery( '.selectize-control' ).on( 'click', function () {
			var selectize = $select[0].selectize;
			selectize.clear(true);
		});

	jQuery("#nf-field-6").addClass('button');
	jQuery(".sitesScroll").click(function() {
		$([document.documentElement, document.body]).animate({
			scrollTop: $(".siteOverviewTitle").offset().top - 80
		}, 1000, 'easeOutCubic');
	});
	jQuery(".industryGroup").click(function(event) {
		event.stopPropagation();
		jQuery(".controlGroup", this).toggle();
		$(".industryGroup .menu li").each(function(i) {
			var $item = $(this); 
			setTimeout(function() { 
				$item.addClass('faderIn');
			}, 100*i);
		});
	});
	jQuery(".openCat").click(function(category) {
		category.stopPropagation();
		jQuery("#catDropdown").toggle();
		$(".categoryGroup .menu li").each(function(i) {
			var $item = $(this); 
			setTimeout(function() { 
				$item.addClass('faderIn');
			}, 100*i);
		});
	});
	$('.up-arrow').html('<i class="fal fa-arrow-up"></i>');
	$('.down-arrow').html('<i class="fal fa-arrow-down"></i>');
	jQuery(document).click( function(){
		$('.controlGroup').hide();
	});	

	
	// jQuery(".controlGroup ul li").click( function(){
	// 	$('.controlGroup').hide();
	// 	$(".filterGroup .menu li").removeClass('faderIn');
	// });	
	jQuery("input[type='radio']:checked").each( 
		function() { 
		   $("label[for='" + this.id + "']").css("border", "solid 3px black");
		} 
	);
	jQuery(window).resize(function(){
		if ($(window).width() < 900){	
			$(".stack td:empty").remove();
		}
	});

	$(".selectBox").one('click', function() {
		$([document.documentElement, document.body]).animate({
			scrollTop: $(".selectBox").offset().top - 100
		}, 800);
	});

	jQuery('.countyPin').mouseenter(function(){ 
		$(this).find('.country').fadeIn();
	});
	jQuery('.countyPin').mouseleave(function(){ 
		$(this).find('.country').fadeOut();
	});

	$('.officeMap').scrollLeft(550);

	jQuery(window).on("scroll", function() {
		if($(window).scrollTop() > 50) {
			$(".header").addClass("headerActive");
		} else {
			//remove the background property so it comes transparent again (defined in your css)
		   $(".header").removeClass("headerActive");
		}
	});


	// jQuery('.staffGrid').each(function(){  
	// 	var highestBox = 0;
	// 	$(this).find('.staffContent').each(function(){
	// 		if($(this).actual('height') > highestBox){  
	// 			highestBox = $(this).actual('height');  
	// 		}
	// 	});
	// 	$(this).find('.staffContent').height(highestBox);
	// }); 


	jQuery('.awardCell:nth-child(1)').show();
	jQuery('.awardCell:nth-child(2)').show();
	jQuery('.showallAwards').click(function() {
		$('.awardCell').show();
		$(this).hide();
	});

	jQuery('.ecd-ptml-iml-selector .menu li a').click(function() {
		$(this).find('span').toggleClass('addRed');
	});

	jQuery('.newsMixContainer').each(function(){  
		var highestBox = 0;
		$(this).find('.newsContent').each(function(){
			if($(this).actual('height') > highestBox){  
				highestBox = $(this).actual('height');  
			}
		});
		$(this).find('.newsContent').height(highestBox);
	}); 



	jQuery('.mrm-maps-selector-item').click(function(){
		var $this = $(this);
		var target = $('.'+$this.data('mrm-target'));
		$('.mrm-maps-selector-item').removeClass('active');
		$('.mrm-maps-map').removeClass('active');
		$this.addClass('active');
		target.addClass('active');
	});

	jQuery('.mrm-filter').click(function(){
		var $this = $(this);
		var target = $('.'+$this.data('mrm-target'));
		if ($this.hasClass('active')) {
			$this.removeClass('active');
			target.removeClass('active');
		} else {
			$this.addClass('active');
			target.addClass('active');
		}
	});

	jQuery('.page-id-94 .countyProfile').append('<img src="/wp-content/themes/TNECD/assets/images/csTexture.png" alt="filter background" class="filterBg">');


	// jQuery('.page-id-90 .titleBanner .large-8').append('<form role="search" method="get" class="searchForm medium-4 cell searchBox" action="https://tnecd18.dsbeta.com/"><input class="search-field" placeholder="Search..." value="" name="s" title="Search for:" type="search"><i class="fal fa-search"></i></form>');
	

	jQuery(".utilityScroll").click(function() {
		$([document.documentElement, document.body]).animate({
			scrollTop: $(".utilityTitle").offset().top - 80
		}, 1000, 'easeOutCubic');
	});
	jQuery(".technicalScroll").click(function() {
		$([document.documentElement, document.body]).animate({
			scrollTop: $(".technicalTitle").offset().top - 80
		}, 1000, 'easeOutCubic');
	});

	if(jQuery(window).width() >= 1024) 
	{
		jQuery('.newsMixContainer').each(function(){  
			var highestBox = 0;
			$(this).find('.newsContent').each(function(){
				if($(this).actual('height') > highestBox){  
					highestBox = $(this).actual('height');  
				}
			});
			$(this).find('.newsContent').height(highestBox);
		}); 
		jQuery('.newsMixContainer').each(function(){  
			var highestBox = 0;
			$(this).find('.newsTitle').each(function(){
				if($(this).actual('height') > highestBox){  
					highestBox = $(this).actual('height');  
				}
			});
			$(this).find('.newsTitle').height(highestBox);
		}); 
	
	}

	if(jQuery(".paternersBanner").next().is('.requestInfo')) {
		$('.paternersBanner .bottomWhiteOverlay').hide();
	}

	jQuery('.tribe-events-title-bar').append('<a class="commishBtn" href="/events/category/commissioner-events/">View Commissioners Public Calendar</a>');

	// jQuery('.staffCard').each(function(){  
	// 	var highestBox = 0;
	// 	$(this).find('.staffContent').each(function(){
	// 		if($(this).actual('height') > highestBox){  
	// 			highestBox = $(this).actual('height');  
	// 		}
	// 	});
	// 	$(this).find('.staffContent').height(highestBox);
	// }); 

	// $(".leftCities label:first-child").trigger("click");
	// $(".rightCities label:nth-child(3)").trigger("click");

	jQuery(".acreageGroup").click(function(event) {
		event.stopPropagation();
		jQuery(".controlGroup", this).toggle();
		$(".acreageGroup .menu li").each(function(i) {
			var $item = $(this); 
			setTimeout(function() { 
				$item.addClass('faderIn');
			}, 100*i);
		});
	});

	
	jQuery(".regionGroup").click(function(event) {
		event.stopPropagation();
		jQuery(".controlGroup", this).toggle();
		$(".regionGroup .menu li").each(function(i) {
			var $item = $(this); 
			setTimeout(function() { 
				$item.addClass('faderIn');
			}, 100*i);
		});
	});
	jQuery(".categoryGroup").click(function(category) {
		category.stopPropagation();
		jQuery(".controlGroup", this).toggle();
		$(".categoryGroup .menu li").each(function(i) {
			var $item = $(this); 
			setTimeout(function() { 
				$item.addClass('faderIn');
			}, 100*i);
		});
	});


	var countyInt;  
	var regionInt;

	function startCounty() {
		clearInterval(regionInt);
		countyInt = setInterval(function(){
			$('.countyView').show();
			$('.regionView').hide();
		}, 10);
	}
	
	function startRegion() {
		clearInterval(countyInt);
		regionInt = setInterval(function(){
			$('.countyView').hide();
			$('.regionView').show();
		}, 10);
	}


	jQuery('.dataCountyBtn').click(function() {
		return startCounty();
	});


	jQuery('.dataRegionBtn').click(function() {
		return startRegion();
	});



	jQuery('.requestInfo a[href*="/contact"]').each(function() {
		$(this).removeAttr("href");
		$(this).attr("data-toggle", "off-canvas-right");
	});

	// $('.requestInfo .buttons li:first-child a').removeAttr("href").attr({"data-toggle": "off-canvas-right"});
	// $('.requestInfo .buttons li:nth-child(2) a').attr({href: "/research-data/interactive-white-papers/"});
	jQuery(document).click( function(){
		$('.controlGroup').hide();
		$(".filterGroup .menu li").removeClass('faderIn');
	});
	
	jQuery( ".blocks" ).last().css( "margin-bottom", "80px" );

	
	


	// $('.incentivesMap #heat-map-selector').val('8').trigger('change');


	jQuery("#cookie-destroy").click(function() {
		Cookies.remove('cookie_food-and-beverage');
		Cookies.remove('cookie_workforce-education');
            Cookies.remove('cookie_business-climate');
            Cookies.remove('cookie_incentives-grants');
            Cookies.remove('cookie_location-infrastructure');
            Cookies.remove('cookie_quality-of-life');
            Cookies.remove('cookie_appliances-and-electrical');
            Cookies.remove('cookie_advanced-materials');
            Cookies.remove('cookie_aerospace-and-defense');
            Cookies.remove('cookie_automotive');
            Cookies.remove('cookie_business-services');
            Cookies.remove('cookie_chemicals');
            Cookies.remove('cookie_distribution-logistics');
            Cookies.remove('cookie_healthcare-medical-devices');
            Cookies.remove('cookie_international');
		console.log(document.cookie);
	});

	
});

